import * as React from 'react';

import styled, { css } from 'styled-components';
import { getWidth } from '@components/styles';

export interface ButtonFixedProps {
  className?: string;
  children: React.ReactNode;
  fixed?: boolean;
  bottomMargin?: string;
  noPadding?: boolean;
}

export const ButtonFixed: React.FC<ButtonFixedProps> = (props) => {
  return <div className={props.className}>{props.children}</div>;
};

export default styled(ButtonFixed)`
  position: fixed;
  width: 100%;
  max-width: 1440px;
  bottom: ${(props) => (props.fixed ? '0' : 'inherit')};
  left: 50%;
  margin-bottom: ${(props) => props.bottomMargin ?? '25px'};
  box-sizing: border-box;
  transform: translate(-50%, 0);
  pointer-events: none;
  padding: 0 30px;
  z-index: 50;

  ${(props) =>
    props.noPadding
      ? css`
          padding: 0;
        `
      : null}

  @media ${({ theme }) => theme.device.tablet} {
    padding: 0;
    padding-right: 30px;
  }

  @media ${({ theme }) => theme.device.desktopL} {
    max-width: 2560px;
  }

  & > button {
    pointer-events: all;
    width: 100%;
    max-width: none;

    @media ${({ theme }) => theme.device.mobileS} {
      max-width: ${getWidth(6.5)};
      margin: 0 auto;
      display: block;
    }

    @media ${({ theme }) => theme.device.tablet} {
      float: right;
      max-width: ${getWidth(3)};
    }
  }
`;
